
import { Injectable } from '@angular/core';
import { TerminalModal } from './model/terminal.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TerminalService {


   constructor(private http: HttpClient) { }
  
    getTerminalList(requestData:RequestData): Observable<any> {
      return this.http.post(environment.baseUrl+'/shop/terminal/get', requestData);
  
    }
  
    getTerminalById(id:number): Observable<any> {
      return this.http.post(environment.baseUrl+'/shop/terminal/get/'+id, '');
  
    }
  
     /**
     * 
     * @param TerminalInfo 
     * Calls the update API to insert/update the record
     */
     update(TerminalInfo: TerminalModal): Observable<any> { 
      if(TerminalInfo.hasOwnProperty("id")){
        return this.http.post(environment.baseUrl+'/shop/terminal/update', TerminalInfo);
      } else{
        return this.http.post(environment.baseUrl+'/shop/terminal/add', TerminalInfo);
      }
    }
  
  
      /**
     * 
     * @param TerminalInfo 
     * Calls the API to delete the record
     */
      delete(TerminalInfo: TerminalModal): Observable<any>  {
        return this.http.post(environment.baseUrl+'/shop/terminal/delete/'+TerminalInfo.id, TerminalInfo);
      }
  
      downloadExcel(requestData: any): Observable<Blob> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    
        return this.http.post(environment.baseUrl + '/shop/terminal/export-terminal-list', requestData, { headers, responseType: 'blob' })
          .pipe(
            //catchError(this.handleError)
          );
    
      }
  
}
